/* istanbul ignore file */
import React from 'react'
import ButtonGroupField from '../../formFields/buttonGroupField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <ButtonGroupField {...fieldProps} />
))
